import { Projects } from '@/pages/authenticated/projects/Projects';

export const ApiQueryKey = {
	productTypes: 'product-types',
	orders: 'orders',
	formTemplates: 'form-templates',
	forms: 'forms',
	users: 'users',
	clients: 'clients',
	admins: 'admins',
	loginHistory: 'logins-history',

	questions: 'questions',
	answers: 'answers',

	content: 'content',
	roles: 'roles',
	globalSettings: 'global-settings',
	projects: 'projects',
	creatorProjects: 'creator/projects',
	configuratorProductDefinition: 'configurator/product-definitions',
	configuratorProductSpecification: 'configurator/product-specifications',
	configuratorProductSpecificationVariantDetails: 'configurator/product-specifications/variant-details',
	attributes: 'attributes',
	attributeValues: 'attribute-values',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
